import { render, staticRenderFns } from "./WsDataTable.vue?vue&type=template&id=64536f5c&scoped=true"
import script from "./WsDataTable.vue?vue&type=script&lang=js"
export * from "./WsDataTable.vue?vue&type=script&lang=js"
import style0 from "./WsDataTable.vue?vue&type=style&index=0&id=64536f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64536f5c",
  null
  
)

export default component.exports